import { IConfig } from "@server/server";
import { appendJWPlayerScripts, getJWPlayerVideoInfo, initJWPlayerTracking, initJWPlayerVideo } from "@util/jwplayer";

const initVideoContainer = async (container: Element, generateSEOMetadata: boolean = false) => {
    const mediaID = container.id.split("-")[1];
    // if we are inside the hero container we auto play.
    const autostart = !!container.closest(".article-image-hero, .post-header__video-player");
    let position = "post_individual_body";
    if (autostart) {
        position = "post_individual_header";
    }
    try {
        const response = await getJWPlayerVideoInfo(mediaID);
        const videoInfo = response.data;

        // We will use this to hook
        // into tracking down the line
        const playerInstance = initJWPlayerVideo({
            videoInfo,
            autostart,
            container,
            mute: !!autostart,
            generateSEOMetadata
        });
        initJWPlayerTracking(playerInstance, videoInfo, position);
    } catch {
        console.error(`Could not find JWPlayer video with mediaId ${mediaID}`);
    }
};

const initJWPlayerVideos = (jwPlayerID: string, config: IConfig = null) => {
    const videoContainers = Array.from(document.getElementsByClassName("jwplayer-container"));

    if (videoContainers.length) {
        appendJWPlayerScripts(jwPlayerID, () => {
            // eslint-disable-next-line no-use-before-define
            videoContainers.forEach((container) => {
                // eslint-disable-next-line no-use-before-define
                JWPlayerVideos.initVideoContainer(container, config?.generateSEOMetadata);
            });
        });
    }
};

export const JWPlayerVideos = {
    initVideoContainer,
    initJWPlayerVideos
};
